import * as actionTypes from "../constants";
import * as eventService from "../services/eventService";

export function createEvent(data, token, dispatch, isRecurrEvent = false) {
  dispatch({
    type: actionTypes.CREATE_EVENT_REQUEST,
  });
  return eventService
    .createEvent(data, token)
    .then(res => {
      if (!isRecurrEvent) {
        res.data.event.rsvps = [
          {
            user: res.data.owner,
            status: "confirmed",
            event: res.data.event._id,
          },
        ];
        dispatch({
          type: actionTypes.CREATE_EVENT_SUCCESS,
          payload: res.data.event,
        });
      }
    })
    .catch(err => {
      throw err;
    });
}

export function getRoomEvents(token, dispatch, roomId, loadMore, offset) {
  dispatch({
    type: actionTypes.GET_ROOM_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getRoomEvents(token, roomId, offset)
    .then(res => {
      dispatch({
        type: actionTypes.GET_ROOM_EVENTS_SUCCESS,
        payload: {
          events: res.data.events,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_ROOM_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getRoomAllEvents(token, dispatch, roomId, loadMore, offset) {
  dispatch({
    type: actionTypes.GET_ROOM_ALLEVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getRoomAllEvents(token, roomId, offset)
    .then(res => {
      dispatch({
        type: actionTypes.GET_ROOM_ALLEVENTS_SUCCESS,
        payload: {
          events: res.data.events,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_ROOM_ALLEVENTS_FAILURE,
      });
      throw err;
    });
}

export function updateEvent(data, eventId, token, dispatch) {
  dispatch({
    type: actionTypes.UPDATE_EVENT_REQUEST,
  });
  return eventService
    .updateEvent(data, eventId, token)
    .then(res => {
      dispatch({
        type: actionTypes.UPDATE_EVENT_SUCCESS,
        payload: res.data.event,
      });
    })
    .catch(err => {
      throw err;
    });
}

export function deleteEvent(eventId, token, dispatch, isGroupDelete = false) {
  dispatch({
    type: actionTypes.DELETE_EVENT_REQUEST,
  });
  return eventService
    .deleteEvent(eventId, token, isGroupDelete)
    .then(res => {
      dispatch({
        type: actionTypes.DELETE_EVENT_SUCCESS,
        payload: res.data.event,
      });
    })
    .catch(err => {
      throw err;
    });
}

export function updateRsvp(data, token, dispatch) {
  dispatch({
    type: actionTypes.UPDATE_RSVP_REQUEST,
    payload: data.event,
  });
  return eventService
    .updateRsvp(data, token)
    .then(res => {
      if (!res.data.message) {
        dispatch({
          type: actionTypes.UPDATE_RSVP_SUCCESS,
          payload: {
            event: res.data.rsvp.event,
          },
        });
        dispatch({
          type: actionTypes.SET_RSVP_UPDATED_EVENT,
          payload: {
            event: res.data.rsvp.event,
          },
        });
      } else {
        dispatch({
          type: actionTypes.SET_RSVP_EVENT_ERROR_MESSAGE,
          payload: {
            message: res.data.message,
          },
        });
      }
    })
    .catch(err => {
      throw err;
    });
}
export function joinEventWaitList(data, token, dispatch) {
  dispatch({
    type: actionTypes.UPDATE_RSVP_REQUEST,
    payload: data,
  });
  return eventService
    .joinEventWaitList(data, token)
    .then(res => {
      dispatch({
        type: actionTypes.UPDATE_RSVP_SUCCESS,
        payload: {
          event: res.data,
        },
      });
    })
    .catch(err => {
      throw err;
    });
}

export function getAllEvents(
  token,
  dispatch,
  loadMore,
  offset,
  limit = 6,
  eventType = "",
) {
  dispatch({
    type: actionTypes.GET_ALL_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getAllEvents(token, offset, limit, eventType)
    .then(res => {
      dispatch({
        type: actionTypes.GET_ALL_EVENTS_SUCCESS,
        payload: {
          events: res.data,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_ALL_EVENTS_FAILURE,
      });
      throw err;
    });
}
export function getMyEvents(token, dispatch) {
  return eventService
    .getMyEvents(token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_MY_EVENTS_SUCCESS,
        payload: {
          events: res.data,
        },
      });
    })
    .catch(err => {
      throw err;
    });
}

export async function getCalenderEvents(
  startDate,
  endDate,
  token,
  dispatch,
  firstTimeFetching,
) {
  dispatch({
    type: actionTypes.GET_CALENDER_EVENTS_REQUEST,
    payload: {
      firstTimeFetching: firstTimeFetching,
    },
  });
  return await eventService
    .getCalenderEvents(startDate, endDate, token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_CALENDER_EVENTS_SUCCESS,
        payload: {
          events: res.data,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_CALENDER_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getAllEventsByUserId(
  token,
  userId,
  dispatch,
  source,
  limit = 20,
) {
  dispatch({
    type: actionTypes.GET_USER_RSVPD_EVENTS_REQUEST,
  });
  return eventService
    .getAllEventsByUserId(token, userId, source, limit)
    .then(res => {
      dispatch({
        type: actionTypes.GET_USER_RSVPD_EVENTS_SUCCESS,
        payload: {
          events: res.data.events,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_USER_RSVPD_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getAllProfileEventsByUserId(
  token,
  userId,
  dispatch,
  source,
  limit,
  offset,
  loadMore,
) {
  dispatch({
    type: actionTypes.GET_P_USER_RSVPD_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getAllEventsByUserId(token, userId, source, limit, offset)
    .then(res => {
      dispatch({
        type: actionTypes.GET_P_USER_RSVPD_EVENTS_SUCCESS,
        payload: {
          events: res.data.events,
          offset: offset,
          loadMore: loadMore,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_P_USER_RSVPD_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getPopularEvents(dispatch, token, loadMore, offset) {
  dispatch({
    type: actionTypes.GET_POPULAR_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getPopularEvents(offset, token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_POPULAR_EVENTS_SUCCESS,
        payload: {
          events: res.data,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_POPULAR_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getLiveEvents(dispatch, token, loadMore, offset) {
  dispatch({
    type: actionTypes.GET_LIVE_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getLiveEvents(offset, token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_LIVE_EVENTS_SUCCESS,
        payload: {
          events: res.data,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_LIVE_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getUpcomingEvents(dispatch, token, loadMore, offset) {
  dispatch({
    type: actionTypes.GET_UPCOMING_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getUpcomingEvents(offset, token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_UPCOMING_EVENTS_SUCCESS,
        payload: {
          events: res.data,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_UPCOMING_EVENTS_FAILURE,
      });
      throw err;
    });
}

export function getHomepageEvents(token, dispatch) {
  dispatch({
    type: actionTypes.GET_HOMEPAGE_EVENT_REQUEST,
  });
  return eventService
    .getHomePageEvents(token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_HOMEPAGE_EVENT_SUCCESS,
        payload: {
          event: res.data.events[0],
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_HOMEPAGE_EVENT_FAILURE,
      });
      throw err;
    });
}

export function updateHomeRsvp(data, token, dispatch) {
  dispatch({
    type: actionTypes.UPDATE_HOME_RSVP_REQUEST,
    payload: data.event,
  });
  return eventService
    .updateRsvp(data, token)
    .then(res => {
      dispatch({
        type: actionTypes.UPDATE_HOME_RSVP_SUCCESS,
        payload: res.data.rsvp,
      });
    })
    .catch(err => {
      throw err;
    });
}

export function getNewlyAddedEvents(dispatch, token, loadMore, offset) {
  dispatch({
    type: actionTypes.GET_NEWLY_ADDED_EVENTS_REQUEST,
    loadMore: loadMore,
  });
  return eventService
    .getNewlyAddedEvents(offset, token)
    .then(res => {
      dispatch({
        type: actionTypes.GET_NEWLY_ADDED_EVENTS_SUCCESS,
        payload: {
          events: res.data,
          loadMore: loadMore,
          offset: offset,
        },
      });
    })
    .catch(err => {
      dispatch({
        type: actionTypes.GET_NEWLY_ADDED_EVENTS_FAILURE,
      });
      throw err;
    });
}
